// extracted by mini-css-extract-plugin
export default {"videoPreview":"Np8yW","active":"wHBQ8","posterImage":"jMA0D","playIcon":"AJlv6","cnImage":"nWSP7","container":"Sx5fW","video":"qLfog"};